import { useEffect } from 'react';
import { useTowerLayout } from '../TowerLayoutProvider';

export default function useHideTowerLayout() {
    const { setHideHeader } = useTowerLayout();

    useEffect(() => {
        setHideHeader(true);
        return () => setHideHeader(false);
    }, [setHideHeader]);
}
